import React from 'react';
import './ProductLogo.css';


const ProductLogo = ({ product, size = 32 }) => {
  const logos = {
    audiences: '/images/icons/audiences-logo.webp',
    ai: '/images/icons/ai-logo.webp',
    attribution: '/images/icons/attribution-logo.webp',
  };

  console.log('logo: ', logos[product]);

  return (
    <img 
      src={logos[product]} 
      alt={`${product} logo`} 
      className={`product-logo product-logo-${product}`}
      style={{ width: size, height: size }} 
    />
  );
}

export default ProductLogo;